// Strings that must stay English in every locale.
// Nested under the same namespaces as the rest of the lang files (e.g. landing.*).

export default {
    landing: {
        agencies_hero_chart_avg: "Avg Review",
        agencies_hero_chart_customers: "Clients",
        agencies_hero_chart_m1: "Jan",
        agencies_hero_chart_m2: "Feb",
        agencies_hero_chart_m3: "Mar",
        agencies_hero_chart_m4: "Apr",
        agencies_hero_chart_m5: "May",
        agencies_hero_chart_m6: "Jun",
        agencies_hero_chart_m7: "Jul",
        agencies_hero_chart_m8: "Aug",
        agencies_hero_chart_m9: "Sep",
        agencies_hero_chart_m10: "Oct",
        agencies_hero_chart_m11: "Nov",
        agencies_hero_chart_m12: "Dec",
        agencies_hero_chart_mrr: "MRR",
        agencies_hero_chart_pill: "+278% growth",
        agencies_hero_chart_reviews: "Total Reviews",
        agencies_hero_url: "portal.northstaragency.com",
        agencies_screen_1_url: "portal.northstaragency.com/projects/1/reviews",
        agencies_screen_2_page_title: "Manage Overrides",
        agencies_screen_2_url: "portal.northstaragency.com/agencies/1/projects/1",
        agencies_screen_4_page_title: "Projects",
        agencies_screen_4_url: "portal.northstaragency.com/agencies/1/projects",
        mcp_assistant_name: "AI Assistant",
        mcp_you: "You",
        review_flow_email_body: "Thanks again for choosing us. We’d love to hear how everything went — it only takes a minute and helps other customers find us.",
        review_flow_email_cta: "Leave a Review",
        review_flow_email_from: "From",
        review_flow_email_from_value: "Your Business",
        review_flow_email_subject: "How did everything go?",
        review_flow_email_subject_label: "Subject",
        review_flow_feedback: "Private Feedback",
        review_flow_form_name: "Karen L.",
        review_flow_form_submit: "Send Feedback",
        review_flow_form_submit_short: "Send",
        review_flow_preview_feedback_body: "Waited longer than expected and communication could have been better.",
        review_flow_preview_google_body: "Friendly, professional, and finished exactly as promised.",
        review_flow_preview_google_cancel: "Cancel",
        review_flow_preview_google_name: "Casey M.",
        review_flow_preview_google_post: "Post",
        review_flow_preview_google_posting: "Posting publicly across Google",
        review_flow_public_option: "Leave a public review",
        review_flow_rating_1: "Poor",
        review_flow_rating_2: "Fair",
        review_flow_rating_3: "Okay",
        review_flow_rating_4: "Good",
        review_flow_rating_5: "Great",
        review_flow_review_body: "Tap a rating below. It only takes a minute.",
        review_flow_review_prompt: "How was your experience?",
        review_flow_review_url: "review.yourbusiness.com",
    },
};
